export type AiStatus = 'idle' | 'running' | 'needs-approval';

export type CompanionEdge =
  | 'document.created'
  | 'ai.finished'
  | 'ai.needs-approval'
  | 'doc.deleted.remote'
  | 'access.denied'
  | 'tab.navigated';

export interface CompanionActivity {
  aiStatus: AiStatus;
  lastEdge: { kind: CompanionEdge; at: number } | null;
}

const EMPTY: CompanionActivity = { aiStatus: 'idle', lastEdge: null };

let current: CompanionActivity = EMPTY;
const listeners = new Set<() => void>();

function commit(next: CompanionActivity) {
  current = next;
  for (const l of listeners) l();
}

export function noteAiStatus(status: AiStatus): void {
  if (current.aiStatus === status) return;
  commit({ ...current, aiStatus: status });
}

export function noteEdge(kind: CompanionEdge, at: number = Date.now()): void {
  commit({ ...current, lastEdge: { kind, at } });
}

export function readCompanionActivity(): CompanionActivity {
  return current;
}

/** Test-only: the module store outlives a render, so isolation needs a reset. */
export function resetCompanionActivityForTests(): void {
  current = EMPTY;
  listeners.clear();
}

export function subscribeCompanionActivity(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
